(function () {
  "use strict";

  var silverModalBindingsDone = false;

  function wireSilverCompareModalOnce() {
    if (silverModalBindingsDone) return;

    var root = document.getElementById("cab-v2-silver-modal");
    if (!root) return;

    silverModalBindingsDone = true;
    var panel = root.querySelector(".cab-v2-silver-modal__panel");
    var closeBtn = root.querySelector(".cab-v2-silver-modal__close");
    var docEl = document.documentElement;
    var bodyEl = document.body;
    var scrollLockY = 0;

    function lockPageScroll() {
      scrollLockY = window.scrollY || docEl.scrollTop || 0;
      docEl.style.overflow = "hidden";
      bodyEl.style.overflow = "hidden";
      /* iOS: overflow on body alone usually still allows background scroll */
      bodyEl.style.position = "fixed";
      bodyEl.style.top = "-" + scrollLockY + "px";
      bodyEl.style.left = "0";
      bodyEl.style.right = "0";
      bodyEl.style.width = "100%";
    }

    function unlockPageScroll() {
      docEl.style.overflow = "";
      bodyEl.style.overflow = "";
      bodyEl.style.position = "";
      bodyEl.style.top = "";
      bodyEl.style.left = "";
      bodyEl.style.right = "";
      bodyEl.style.width = "";
      window.scrollTo(0, scrollLockY);
    }

    function openSilverModal(ev) {
      if (ev) {
        ev.preventDefault();
        ev.stopPropagation();
      }
      root.removeAttribute("hidden");
      root.setAttribute("aria-hidden", "false");
      root.classList.add("cab-v2-silver-modal--visible");
      lockPageScroll();
      if (closeBtn) {
        window.setTimeout(function () {
          closeBtn.focus();
        }, 0);
      }
    }

    function closeSilverModal() {
      if (!root.hasAttribute("hidden")) {
        root.setAttribute("aria-hidden", "true");
        root.classList.remove("cab-v2-silver-modal--visible");
        root.setAttribute("hidden", "");
        unlockPageScroll();
      }
    }

    document.addEventListener(
      "click",
      function (e) {
        var trig = e.target.closest(
          ".cab-v2-filter-info-icon, [data-cab-v2-modal-open], .cab-v2-silver-modal-open"
        );
        if (!trig) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        openSilverModal(null);
      },
      true
    );

    document.addEventListener("keydown", function (e) {
      if (e.key !== "Escape") return;
      var m = document.getElementById("cab-v2-silver-modal");
      if (!m || m.hasAttribute("hidden")) return;
      closeSilverModal();
    });

    root.addEventListener("click", function (e) {
      var closeHit = e.target && e.target.closest && e.target.closest(".cab-v2-silver-modal__close");
      if (closeHit && root.contains(closeHit)) {
        e.preventDefault();
        e.stopPropagation();
        closeSilverModal();
        return;
      }
      if (panel && panel.contains(e.target)) {
        e.stopPropagation();
        return;
      }
      e.stopPropagation();
      closeSilverModal();
    });
  }

  window.cabV2WireSilverModalOnce = wireSilverCompareModalOnce;

  function scheduleRetries() {
    function tick() {
      wireSilverCompareModalOnce();
    }

    tick();
    window.setTimeout(tick, 0);
    window.setTimeout(tick, 300);
    window.setTimeout(tick, 900);
    window.addEventListener("load", tick);
    window.setTimeout(tick, 2100);

    if (typeof window.MutationObserver === "undefined") return;

    var moTimer;
    function debouncedTick() {
      window.clearTimeout(moTimer);
      moTimer = window.setTimeout(tick, 48);
    }

    try {
      var mo = new MutationObserver(debouncedTick);
      mo.observe(document.documentElement, { attributes: true, attributeFilter: ["class"] });
      if (document.body) {
        mo.observe(document.body, { attributes: true, attributeFilter: ["class"] });
      } else {
        document.addEventListener(
          "DOMContentLoaded",
          function () {
            if (document.body) {
              mo.observe(document.body, { attributes: true, attributeFilter: ["class"] });
            }
            debouncedTick();
          },
          { once: true }
        );
      }
    } catch (_eMo) { /* ignore */ }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleRetries);
  } else {
    scheduleRetries();
  }
})();
